import { render, staticRenderFns } from "./EntityMove.vue?vue&type=template&id=6e67920c&scoped=true"
import script from "./EntityMove.vue?vue&type=script&lang=js"
export * from "./EntityMove.vue?vue&type=script&lang=js"
import style0 from "./EntityMove.vue?vue&type=style&index=0&id=6e67920c&lang=scss&scoped=true"
import style1 from "./EntityMove.vue?vue&type=style&index=1&id=6e67920c&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e67920c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/aimer/TM/KB/Knowledge-base/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e67920c')) {
      api.createRecord('6e67920c', component.options)
    } else {
      api.reload('6e67920c', component.options)
    }
    module.hot.accept("./EntityMove.vue?vue&type=template&id=6e67920c&scoped=true", function () {
      api.rerender('6e67920c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/cloud-disk/src/components/EntityMove.vue"
export default component.exports